import React, { useEffect, useState, useRef, useMemo } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/AdoptSection.css";
import VirtualAdoptModal from "../components/virtualAdoptModal";
import { API_URL } from "../api.js";

function AdoptCarousel() {
  const { t } = useTranslation("adoptSection");
  const [animals, setAnimals] = useState([]);
  const [selectedAnimal, setSelectedAnimal] = useState(null);
  const sliderRef = useRef(null);

  /* ================= FETCH ANIMALS ================= */
  useEffect(() => {
    fetch(`${API_URL}/api/animals`)
      .then((res) => res.json())
      .then(setAnimals)
      .catch((err) => console.error("Eroare la preluare animale:", err));
  }, []);

  /* ================= DETECT MOBILE REAL ================= */
  const isMobile = useMemo(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(max-width: 768px)").matches;
  }, []);

  /* ================= FORCE SLICK RECALC ================= */
  useEffect(() => {
    if (sliderRef.current && animals.length > 0) {
      setTimeout(() => {
        try {
          sliderRef.current.slickGoTo(0, true);
          sliderRef.current.innerSlider.onWindowResized();
        } catch (e) {
          console.warn("Slick resize fallback:", e);
        }
      }, 400);
    }
  }, [animals, isMobile]);

  /* ================= SLICK SETTINGS ================= */
  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: isMobile ? 1 : 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1280,
          settings: { slidesToShow: 3 },
        },
        {
          breakpoint: 1024,
          settings: { slidesToShow: 2 },
        },
      ],
    }),
    [isMobile]
  );

  return (
    <section className="home-adopt-carousel-section">
      <h2 className="home-section-title">
        <Link to="/adopt" className="home-adopt-title-link">
          {t("title")}
        </Link>
      </h2>

      <div className="home-adopt-carousel-container">
        <Slider ref={sliderRef} {...settings}>
          {animals.map((animal) => (
            <div key={animal.id} className="home-adopt-slide">
              <div className="home-adopt-card">
                {animal.image ? (
                  <div className="home-adopt-image-container">
                    <img src={animal.image} alt={animal.name} loading="lazy" />
                  </div>
                ) : (
                  <div className="home-adopt-image-placeholder">
                    Fără imagine
                  </div>
                )}

                <div className="home-adopt-card-body">
                  <h3>{animal.name}</h3>
                  <button
                    className="home-adopt-button"
                    onClick={() => setSelectedAnimal(animal)}
                  >
                    {t("button")}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {selectedAnimal && (
        <VirtualAdoptModal
          animal={selectedAnimal}
          onClose={() => setSelectedAnimal(null)}
        />
      )}
    </section>
  );
}

export default AdoptCarousel;
